import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Link, type MetaFunction } from "@remix-run/react";

import d1 from "../images/faqs/d1.jpg";
import d2 from "../images/faqs/d2.jpg";
import d3 from "../images/faqs/d3.jpg";
import m1 from "../images/faqs/m1.jpg";
import m2 from "../images/faqs/m2.jpg";
import m3 from "../images/faqs/m3.jpg";

export const meta: MetaFunction = ({ data }) => {
  return [
    { title: "Admirer Store - FAQ's" },
    {
      name: "description",
      content:
        "Get answers to common questions about your order, shipping times, order tracking, returns, and more. Find everything you need to shop with confidence!",
    },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "Admirer Store - FAQ's" },
    {
      property: "og:description",
      content:
        "Get answers to common questions about your order, shipping times, order tracking, returns, and more. Find everything you need to shop with confidence!",
    },
  ];
};

export default function Index() {
  return (
    <div className="py-8 px-4">
      <div className="mx-auto text-base leading-7">
        <h1 className="text-3xl font-bold">FAQs</h1>
        <div className="mx-auto max-w-screen-lg overflow-hidden px-0 py-12 sm:px-6 lg:px-8">
          <dl>
            <Disclosure as="div" className="border-b border-gray-500 py-2">
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="w-full text-left text-gray-400">
                      <div className="grid grid-cols-6  gap-1">
                        <div className="col-span-5 flex flex-col justify-center ">
                          <p className="text-base text-black dark:text-white sm:text-xl font-bold">
                            How long does it take for my order to arrive?
                          </p>
                        </div>

                        <div className="col-span-1 flex flex-col justify-center ">
                          <ChevronRightIcon
                            className={`${
                              open ? "rotate-90 transform" : ""
                            } h-7 w-7 flex-shrink-0 self-end text-black dark:text-white sm:-mr-5 md:h-9 md:w-9`}
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2">
                    {({ close }) => {
                      return (
                        <div>
                          <p>
                            The estimated delivery time displayed on the checkout page includes the preparation time to
                            dispatch and also the shipping time altogether. The delivery time will vary a lot from
                            country to country.{" "}
                          </p>
                          <p>On each order we send you an Email with the tracking number.</p>
                        </div>
                      );
                    }}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </dl>

          <dl>
            <Disclosure as="div" className="border-b border-gray-500 py-2">
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="w-full text-left text-gray-400">
                      <div className="grid grid-cols-6 gap-1">
                        <div className="col-span-5 flex flex-col justify-center ">
                          <p className="text-base text-black dark:text-white sm:text-xl font-bold">
                            How can I check my order status?
                          </p>
                        </div>

                        <div className="col-span-1 flex flex-col justify-center ">
                          <ChevronRightIcon
                            className={`${
                              open ? "rotate-90 transform" : ""
                            } h-7 w-7 flex-shrink-0 self-end text-black dark:text-white sm:-mr-5 md:h-9 md:w-9`}
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2">
                    {({ close }) => {
                      return (
                        <div>
                          <p>
                            You need to{" "}
                            <Link to="/user/sign-in" className="text-admirerBlue">
                              Sign in
                            </Link>{" "}
                            to your account, and then you need to follow the next steps:
                          </p>

                          <p>
                            <b>1.</b> Go to your user panel by clicking on the initials located in the top right menu.{" "}
                          </p>
                          <div className="grid grid-cols-6 gap-6">
                            <div className="sm:col-span-4 col-span-5 ">
                              <img className="block sm:hidden" src={m1} alt="first step mobile" />
                              <img className="hidden sm:block" src={d1} alt="first step desktop" />
                            </div>
                          </div>
                          <br />
                          <p>
                            <b>2.</b> Within the orders section, click on 'View my orders'.
                          </p>
                          <div className="grid grid-cols-6 gap-6">
                            <div className="sm:col-span-4 col-span-5 ">
                              <img className="block sm:hidden" src={m2} alt="second step mobile" />
                              <img className="hidden sm:block" src={d2} alt="second step desktop" />
                            </div>
                          </div>
                          <br />
                          <p>
                            <b>3.</b> In this section, you'll be able to see the list of all your orders. Click on the
                            option to view details so you can see the status of your order. On mobile devices, you can
                            find it in the following section:
                          </p>
                          <div className="grid grid-cols-6 gap-6">
                            <div className="sm:col-span-4 col-span-5 ">
                              <img className="block sm:hidden" src={m3} alt="third step mobile" />
                              <img className="hidden sm:block" src={d3} alt="third step desktop" />
                            </div>
                          </div>
                        </div>
                      );
                    }}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </dl>

          <dl>
            <Disclosure as="div" className="border-b border-gray-500 py-2">
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="w-full text-left text-gray-400">
                      <div className="grid grid-cols-6 gap-1">
                        <div className="col-span-5 flex flex-col justify-center ">
                          <p className="text-base text-black dark:text-white sm:text-xl font-bold">
                            What payment methods do you handle?
                          </p>
                        </div>

                        <div className="col-span-1 flex flex-col justify-center ">
                          <ChevronRightIcon
                            className={`${
                              open ? "rotate-90 transform" : ""
                            } h-7 w-7 flex-shrink-0 self-end text-black dark:text-white sm:-mr-5 md:h-9 md:w-9`}
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2">
                    {({ close }) => {
                      return (
                        <div>
                          <p>
                            We accept Visa, Mastercard, PayPal, Apple Pay and some Crypto Currencies (Bitcoin, Ethereum,
                            USDC, Litecoin and Dogecoin ) via crypto.com Payments.
                          </p>
                        </div>
                      );
                    }}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </dl>

          <dl>
            <Disclosure as="div" className="border-b border-gray-500 py-2">
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="w-full text-left text-gray-400">
                      <div className="grid grid-cols-6 gap-1">
                        <div className="col-span-5 flex flex-col justify-center ">
                          <p className="text-base text-black dark:text-white sm:text-xl font-bold">
                            What if I receive a defective item?
                          </p>
                        </div>

                        <div className="col-span-1 flex flex-col justify-center ">
                          <ChevronRightIcon
                            className={`${
                              open ? "rotate-90 transform" : ""
                            } h-7 w-7 flex-shrink-0 self-end text-black dark:text-white sm:-mr-5 md:h-9 md:w-9`}
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2">
                    {({ close }) => {
                      return (
                        <div>
                          <p>
                            We got you covered! Please{" "}
                            <a className="text-admirerBlue" href="mailto:contact@admirer.store">
                              contact us
                            </a>{" "}
                            with a photo of the defects within 10 days from receiving your order (according to the
                            delivery date on the tracking record, if applicable) and we will arrange a replacement of
                            the same product for you right away after verifying the quality issue. If your product(s) is
                            discontinued or out-of-stock, it may be replaced by a similar option.
                          </p>
                          <p>
                            It is important that you review our{" "}
                            <Link to="/help/return-policy" className="text-admirerBlue">
                              Return Policy
                            </Link>{" "}
                            so you can see what are the valid reasons for return items
                          </p>
                        </div>
                      );
                    }}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </dl>
        </div>
      </div>
    </div>
  );
}
